import { useEffect, useState, forwardRef } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { Box, useMediaQuery } from '@mui/material';
import { theme } from '../../../utils/theme/godzilla_light';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

const styles = {
    dialogWrapper: {
        backgroundColor: "#F8F8F8",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center"
    },
    closeIconStyle: {
        display: "flex",
        alignSelf: "flex-end",
        backgroundColor: "#5557591F",
        width: "34px",
        height: "34px",
        borderRadius: "17px"
    }
}

interface IDialogProps {
    children: React.ReactNode;
    isOpen: boolean;
    boxTitle?: string;
    onClose?: () => void;
    handleSave?: ()=> void;
}

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogModalHOC = (props: IDialogProps) => {
    const isMobile = useMediaQuery(theme.breakpoints.down(950))
    const { children, isOpen, boxTitle, onClose , handleSave} = props
    const [open, setOpen] = useState(isOpen);

    useEffect(() => {
        if (isOpen) {
            setOpen(isOpen)
        }
    }, [isOpen])

    const handleClose = () => {
        setOpen(false);
        if(onClose){
            onClose()
        }
    };

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            slots={{ transition: Transition }}>
            <Box sx={styles.dialogWrapper}>
                <Box display={"flex"} flexDirection={"column"} sx={{ backgroundColor: "#fff", py: "39px", px: isMobile ?"31px":"150px",width:isMobile?"70%":"40%" }}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        sx={styles.closeIconStyle}
                        aria-label="close">
                        <CloseIcon sx={{ width: "22px", height: "22px", color: "#404144" }} />
                    </IconButton>
                    <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
                        <Typography sx={{ ...theme.typography.opticianBodyRegular,fontSize:"26px",pr:"10px",textAlign:"center" }}>{boxTitle}</Typography>
                        {children}
                        <Button
                            onClick={handleSave}
                            variant='contained'
                            sx={{ ...theme.button.contained.primary, width: "120px", mt: "30px" }}>
                            <Typography sx={{ ...theme.typography.body1SemiBold, color: "#fff" }}>{"Save"}</Typography>
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
}
export default DialogModalHOC